import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getFormattedValue } from '../../../dashboardUtils';

function ThresholdValueDisplay({ thresholdValue, color, suffix }) {
    return (
        <div className="gauge-value-display">
            <p style={{ color }}>{getFormattedValue(thresholdValue, suffix)}</p>
        </div>
    );
}

ThresholdValueDisplay.propTypes = {
    color: PropTypes.string,
    suffix: PropTypes.string,
    thresholdValue: PropTypes.node.isRequired,
};

ThresholdValueDisplay.defaultProps = {
    color: '#575757',
    suffix: '',
};

export default React.memo(ThresholdValueDisplay, (prevProps, nextProps) =>
    _.isEqual(prevProps.thresholdValue, nextProps.thresholdValue)
);
